import { Dialog } from "@constellation-academy/epic-ui";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { persologElementQuestionFormDialog_PersologElementFragment$key } from "@relay/persologElementQuestionFormDialog_PersologElementFragment.graphql";
import { persologElementQuestionFormDialog_QuestionFragment$key } from "@relay/persologElementQuestionFormDialog_QuestionFragment.graphql";

import {
	PERSOLOG_ELEMENT_FRAGMENT,
	QUESTION_FRAGMENT,
} from "./persolog-element-question-form-dialog.graphql";
import { PersologElementQuestionFormDialogProps } from "./persolog-element-question-form-dialog.types";
import { PersologElementQuestionForm } from "../persolog-element-question-form";

export const PersologElementQuestionFormDialog = ({
	persologElementFragmentRef,
	questionFragmentRef,
	onHide,
	onSubmit,
	isVisible,
}: PersologElementQuestionFormDialogProps) => {
	const { t } = useTranslation("common");
	const persologElement =
		useFragment<persologElementQuestionFormDialog_PersologElementFragment$key>(
			PERSOLOG_ELEMENT_FRAGMENT,
			persologElementFragmentRef,
		);
	const question = useFragment<persologElementQuestionFormDialog_QuestionFragment$key>(
		QUESTION_FRAGMENT,
		questionFragmentRef ?? null,
	);

	const dialogTitle = question
		? t("educationalOffer.questions.editTitle", { title: question.title })
		: t("educationalOffer.questions.createTitle");
	if (!persologElement) return;

	return (
		<Dialog visible={isVisible} onHide={onHide} title={dialogTitle}>
			<PersologElementQuestionForm
				persologElementFragmentRef={persologElement}
				questionFragmentRef={question}
				onSubmit={onSubmit}
			/>
		</Dialog>
	);
};
